import axios from "axios";
import { Message } from "element-ui";
import { UserModule } from "@/store/module/user";
import qs from "qs";

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 99999,
});

// 报错处理，短时间内触发多个报错时，重复的报错只提示一次
let errorMessageList: string[] = [];
function errorMessage(msg: string) {
  if (errorMessageList.length === 0) {
    const timer = setTimeout(() => {
      errorMessageList.map((msg) => {
        Message({
          showClose: true,
          message: msg,
          type: "error",
        });
      });
      errorMessageList = [];
      clearTimeout(timer);
    }, 600);
  }
  errorMessageList = [...new Set([...errorMessageList, msg])];
}
// warning同理
let warningMessageList: string[] = [];
function warningMessage(msg: string) {
  if (warningMessageList.length === 0) {
    const timer = setTimeout(() => {
      warningMessageList.map((msg) => {
        Message({
          showClose: true,
          message: msg,
          type: "warning",
        });
      });
      warningMessageList = [];
      clearTimeout(timer);
    }, 600);
  }
  warningMessageList = [...new Set([...warningMessageList, msg])];
}

//http request 拦截器
service.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    config.headers = {
      "Content-Type": "application/json",
      "TS-TOKEN": token,
      "X-APP-NAME": "musicwowts",
      "X-DEVICE-TYPE": "5",
    };
    if (config.method === "get") {
      config.paramsSerializer = function (params) {
        return qs.stringify(params, { arrayFormat: "repeat" });
      };
    }
    return config;
  },
  (error) => {
    Message({
      showClose: true,
      message: error,
      type: "error",
    });
    return Promise.reject(error);
  }
);

//http response 拦截器
service.interceptors.response.use(
  (response) => {
    const msg = response.data.message;
    if (response.headers["new-token"]) {
      UserModule.SET_TOKEN(response.headers["new-token"]);
    }
    if (response.data.error_code === 0) {
      return response.data;
    } else if (
      response.data.error_code === 21009004 ||
      response.data.error_code === 21020001 ||
      response.data.error_code === 21009006 ||
      response.data.error_code === 21015005 ||
      response.data.error_code === 21026013 ||
      response.data.error_code === 21024005 ||
      response.data.error_code === 21004018 ||
      response.data.error_code === 21009009 ||
      response.data.error_code === 21005021 ||
      response.data.error_code === 18022004 ||
      response.data.error_code === 18022005 ||
      response.data.error_code === 18022014 ||
      response.data.error_code === 21009011 || // 创建学员 - 手机号已存在
      response.data.error_code === 21050006 || // wow学院 - 文档已更新
      response.data.error_code === 21009012 ||
      response.data.error_code === 18022002 ||
      response.data.error_code === 21031001 ||
      response.data.error_code === 21016024 // 扫码收款，二维码非有效支付码
    ) {
      // 特殊情况，直接返回数据到具体页面处理，不进行统一的错误处理
      return response.data;
    } else if (
      response.data.error_code === 21009007 ||
      response.data.error_code === 21009008 ||
      response.data.error_code === 21010008 ||
      response.data.error_code === 21010009
    ) {
      errorMessage(msg);
      return;
    } else if (
      response.data.error_code === 21003011 ||
      response.data.error_code === 21003003 ||
      response.data.error_code === 21004009 ||
      response.data.error_code === 21003001
    ) {
      // 登录状态失效
      errorMessage(msg);
      setTimeout(() => {
        UserModule.LOGIN_OUT(); // 不需要调logout接口
      }, 1500);
      return Promise.reject(msg);
    } else if (response.data.error_code === 21007025) {
      // warning黄色提示
      warningMessage(msg);
      return Promise.reject(msg);
    } else {
      // 剩余均为error红色提示
      errorMessage(msg);
      return Promise.reject(msg);
    }
  },
  (error) => {
    console.log(error.stack);
    let emsg: any = "";
    if (error.stack.indexOf("Network Error") >= 0) {
      emsg = "似乎已断开与网络的连接";
    } else {
      emsg = error.message;
    }
    errorMessage(emsg);
    return Promise.reject(error);
  }
);

export default service;
